/**
 * Location actions.
 * @module actions/location
 */
export const GET_LOCATION = 'GET_LOCATION';

/**
 * Get location.
 * @function getLocation
 * @returns {Object} Get location action.
 */
export function getLocation(path) {
  return {
    type: GET_LOCATION,
    request: {
      op: 'get',
      path: `${path}/@location`,
    },
  };
}

export const ADD_LOCATION = 'ADD_LOCATION';

/**
 * Add location.
 * @function addLocation
 * @returns {Object} Add location action.
 */
export function addLocation(path) {
  return {
    type: ADD_LOCATION,
    request: {
      op: 'post',
      path: `${path}/@locations`,
    },
  };
}

export const MODIFY_LOCATION = 'MODIFY_LOCATION';

/**
 * Modify location.
 * @function modifyLocation
 * @returns {Object} modify location action.
 */
export function modifyLocation(path, data) {
  return {
    type: MODIFY_LOCATION,
    request: {
      op: 'patch',
      path: `${path}/@locations`,
      data,
    },
  };
}

export const DELETE_LOCATION = 'DELETE_LOCATION';

/**
 * Delete location.
 * @function deleteLocation
 * @returns {Object} delete location action.
 */
export function deleteLocation(path) {
  return {
    type: DELETE_LOCATION,
    request: {
      op: 'del',
      path: `${path}/@locations`,
    },
  };
}
